export const QUERIES = {
    DISCORD_ACCOUNT: "discord_account",
    LM_SESSION: "lm_account",
    SEARCH_MAPS: "search_maps",
    SEARCH_ADVENTURERS: "search_adventurers",
};
